/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 18 2025
 **/

import { useRef, PointerEvent } from "react";

type Position = { x: number; y: number };

export default function useClickWithoutDrag() {
	const dragThreshold = 10;

	const startPosition = useRef<Position>({ x: 0, y: 0 });

	const getDistance = (v1: Position, v2: Position) => {
		return Math.sqrt((v2.x - v1.x) ** 2 + (v2.y - v1.y) ** 2);
	};

	const onPointerDown = (e: PointerEvent) => {
		startPosition.current = { x: e.clientX, y: e.clientY };
	};

	const onPointerUp = (e: PointerEvent, callback: () => void) => {
		const distance = getDistance({ x: e.clientX, y: e.clientY }, startPosition.current);
		if (distance < dragThreshold) callback();
	};

	return { onPointerDown, onPointerUp };
}
